import {useTranslation} from "react-i18next";

export const Colabs = () => {
  const [ t ] = useTranslation(['home']);
  return (
    <div className="container  colabs__container">
      <div className="row">
        <div className="col-12">
          <h1 className="section-title rleft ">{t('CollaboratingCompanies')}</h1>
        </div>
      </div>
      <div className="colabs__wrapper_two pt-5">
        {colabs.map((colab) => (
          <div
            key={colab.name}
            className="p-xs-4 p-5  member__card col-6 col-lg-3 col-sm-4 col-md-4"
          >
            <a href={colab.link} target="_blank">
              <img src={require(`../assets/images/${colab.img}`)} alt="" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

const colabs = [
  {
    img: "vibra.png",
    link: "https://tracker.racksmafia.com/vibra",
    name: "Vibra",
  },
  {
    img: "logobit.svg",
    link: "https://tracker.racksmafia.com/bitbase",
    name: "BitBase",
  },
  {
    img: "myprotein.svg",
    link: "https://tracker.racksmafia.com/myprotein-web",
    name: "My protein",
  },
  {
    img: "akuna.png",
    link: "https://tracker.racksmafia.com/akuna",
    name: "My protein",
  },
  {
    img: "pandaclub.png",
    link: "https://tracker.racksmafia.com/panda-club",
    name: "Panda club",
  },
  {
    img: "toyrooms.png",
    link: "https://toyroommadrid.com/",
    name: "Toy room Madrid",
  },
  {
    img: "afl.png",
    link: "https://aflmma.es/",
    name: "Ansgar Fighting League",
  },
  {
    img: "comittee.png",
    link: "https://www.instagram.com/committeevalencia/?hl=es",
    name: "Committee Valencia",
  },



];
